import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Loader } from "~/Components";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { fields, fieldsReady } from "../constantsdum";
import { useOurBrand } from "../Corporate.hook";

export const OurBrandPageContent: React.FC = (): JSX.Element => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();
  const approveQuery = new URLSearchParams(location.search);
  const approveId = approveQuery.get("id");
  const [fieldData, setFieldData] = useState<any>();

  const { data: brandData, error, isLoading, isError, refetch: refetchOurBrand } = useOurBrand();
  const {
    data: brandDataById,
    isLoading: isLoadingBrand,
    refetch: refetchOurBrandById,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (!approveId) {
      refetchOurBrand();
    }
  }, []);

  useEffect(() => {
    if (approveId) {
      refetchOurBrandById();
    }
  }, [approveId]);

  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const OurBrandFormConfig: FormConfig = {
    initialValues: {
      field_content_english_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.title)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.title),
      field_content_english_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.description)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.description),
      field_content_english_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_english_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_english)?.data?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_english)?.data?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_english_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_english?.data?.image,
              },
            ]),
      field_content_english_vision_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.vision?.title)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.vision?.title),
      field_content_english_vision_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.vision?.description)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.vision?.description),
      field_content_english_vision_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_english_vision_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_english)?.data?.vision?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_english)?.data?.vision?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_english_vision_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_english?.data?.vision?.image,
              },
            ]),
      field_content_english_brandPromise_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.brandPromise?.title)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.brandPromise?.title),
      field_content_english_brandPromise_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.brandPromise?.description)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.brandPromise?.description),
      field_content_english_brandPromise_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_english_brandPromise_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_english)?.data?.brandPromise?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_english)?.data?.brandPromise?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_english_brandPromise_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_english?.data?.brandPromise?.image,
              },
            ]),
      field_content_english_nextPage_name:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.nextPage?.name)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.nextPage?.name),
      field_content_english_nextPage_link:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_english)?.data?.nextPage?.link)
          : decodeHTML(brandData?.[0]?.field_content_english?.data?.nextPage?.link),

      field_content_malay_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.title)
          : decodeHTML(brandData?.[0]?.field_content_malay?.data?.title),
      field_content_malay_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.description)
          : decodeHTML(brandData?.[0]?.field_content_malay?.data?.description),
      field_content_malay_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_malay_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_malay_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_malay?.data?.image,
              },
            ]),
      field_content_malay_vision_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.vision?.title)
          : decodeHTML(brandData?.[0]?.field_content_malay?.data?.vision?.title),
      field_content_malay_vision_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.vision?.description)
          : decodeHTML(brandData?.[0]?.field_content_malay?.data?.vision?.description),
      field_content_malay_vision_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_malay_vision_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.vision?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.vision?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_malay_vision_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_malay?.data?.vision?.image,
              },
            ]),
      field_content_malay_brandPromise_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.brandPromise?.title)
          : decodeHTML(brandData?.[0]?.field_content_malay?.data?.brandPromise?.title),
      field_content_malay_brandPromise_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.brandPromise?.description)
          : decodeHTML(brandData?.[0]?.field_content_malay?.data?.brandPromise?.description),
      field_content_malay_brandPromise_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_malay_brandPromise_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.brandPromise?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.brandPromise?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_malay_brandPromise_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_malay?.data?.brandPromise?.image,
              },
            ]),
      field_content_malay_nextPage_name:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_malay)?.data?.nextPage?.name)
          : decodeHTML(brandData?.[0]?.field_content_malay?.data?.nextPage?.name),
      field_content_malay_nextPage_link: brandData?.[0]?.field_content_malay?.data?.nextPage?.link,

      field_content_mandarin_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.title)
          : decodeHTML(brandData?.[0]?.field_content_mandarin?.data?.title),
      field_content_mandarin_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.description)
          : decodeHTML(brandData?.[0]?.field_content_mandarin?.data?.description),
      field_content_mandarin_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_mandarin_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_mandarin_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_mandarin?.data?.image,
              },
            ]),
      field_content_mandarin_vision_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.vision?.title)
          : decodeHTML(brandData?.[0]?.field_content_mandarin?.data?.vision?.title),
      field_content_mandarin_vision_image: brandDataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_content_mandarin_vision_image.png",
              status: "done",
              url:
                JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.vision?.image?.[0]?.url ||
                JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.vision?.image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_content_mandarin_vision_image.png",
              status: "done",
              url: brandData?.[0]?.field_content_mandarin?.data?.vision?.image,
            },
          ]),
      field_content_mandarin_brandPromise_title:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.brandPromise?.title)
          : decodeHTML(brandData?.[0]?.field_content_mandarin?.data?.brandPromise?.title),
      field_content_mandarin_brandPromise_description:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.brandPromise?.description)
          : decodeHTML(brandData?.[0]?.field_content_mandarin?.data?.brandPromise?.description),
      field_content_mandarin_brandPromise_image:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML([
              {
                uid: "-1",
                name: "field_content_mandarin_brandPromise_image.png",
                status: "done",
                url:
                  JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.brandPromise?.image?.[0]?.url ||
                  JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.brandPromise?.image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "field_content_mandarin_brandPromise_image.png",
                status: "done",
                url: brandData?.[0]?.field_content_mandarin?.data?.brandPromise?.image,
              },
            ]),
      field_content_mandarin_nextPage_name:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.nextPage?.name)
          : decodeHTML(brandData?.[0]?.field_content_mandarin?.data?.nextPage?.name),
      field_content_mandarin_nextPage_link:
        brandDataById?.payload && !isLoadingBrand
          ? decodeHTML(JSON.parse(brandDataById?.payload?.field_content_mandarin)?.data?.nextPage?.link)
          : decodeHTML(brandData?.[0]?.field_content_mandarin?.data?.nextPage?.link),
    },
    fields: fieldData?.ourBrandPageContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("updatePayload-1", data);
    let imageKeys: any = [
      "field_content_mandarin_brandPromise_image",
      "field_content_mandarin_vision_image",
      "field_content_mandarin_image",
      "field_content_malay_brandPromise_image",
      "field_content_malay_vision_image",
      "field_content_malay_image",
      "field_content_english_brandPromise_image",
      "field_content_english_vision_image",
      "field_content_english_image",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        console.log("itemImage-11", field);
        if (field && field[0]) {
          if (field[0].originFileObj) {
            console.log("uploadImage", field[0].originFileObj);
            const formData = new FormData();
            formData.append("upload-file", field[0].originFileObj);
            formData.append("application", "CORPORATE");
            const res: any = await post("management/upload-file", formData);
            console.log("uploadImage1", res);
            if (res) {
              data[key] = res.response.data;
            }
          } else if (field[0].url) {
            data[key] = field[0].url;
          }
        }
      } catch (error) {}
    }

    let payload;
    if (query.get("activeTab") === "ourBrand") {
      payload = {
        action: action,
        method: method,
        module: "CorporateProfile",
        subModule: `${query?.get("activeTab")}_${query.get("subActiveTab")}`,
        type: "DEDICATED",
        application: "MAHB_CORPORATE",
        reviewNotes: reviewNotes,
        moduleKey: "MAHB_CORPORATE_Corporate Profile_Our Brand",
        appList: [
          {
            appName: "MAHB_CORPORATE",
            apiUrl: apiUrl,
          },
        ],
        payload: {
          id: data?.id || brandData?.[0]?.id || brandDataById?.payload?.id,
          field_content_english: JSON.stringify({
            data: {
              title: data?.field_content_english_title ? data?.field_content_english_title : "",
              description: data?.field_content_english_description ? data?.field_content_english_description : "",
              image: data?.field_content_english_image ? data?.field_content_english_image : "",
              vision: {
                title: data?.field_content_english_vision_title ? data?.field_content_english_vision_title : "",
                description: data?.field_content_english_vision_description
                  ? data?.field_content_english_vision_description
                  : "",
                image: data?.field_content_english_vision_image ? data?.field_content_english_vision_image : "",
              },
              brandPromise: {
                title: data?.field_content_english_brandPromise_title
                  ? data?.field_content_english_brandPromise_title
                  : "",
                description: data?.field_content_english_brandPromise_description
                  ? data?.field_content_english_brandPromise_description
                  : "",
                image: data?.field_content_english_brandPromise_image
                  ? data?.field_content_english_brandPromise_image
                  : "",
              },
              nextPage: {
                name: data?.field_content_english_nextPage_name ? data?.field_content_english_nextPage_name : "",
                link: data?.field_content_english_nextPage_link ? data?.field_content_english_nextPage_link : "",
              },
            },
          }),
          field_content_malay: JSON.stringify({
            data: {
              title: data?.field_content_malay_title ?? "",
              description: data?.field_content_malay_description ?? "",
              image: data?.field_content_english_image ?? "",
              vision: {
                title: data?.field_content_malay_vision_title ?? "",
                description: data?.field_content_malay_vision_description ?? "",
                image: data?.field_content_english_vision_image ?? "",
              },
              brandPromise: {
                title: data?.field_content_malay_brandPromise_title ?? "",
                description: data?.field_content_malay_brandPromise_description ?? "",
                image: data?.field_content_english_brandPromise_image ?? "",
              },
              nextPage: {
                name: data?.field_content_malay_nextPage_name ?? "",
                link: data?.field_content_malay_nextPage_link ?? "",
              },
            },
          }),
          field_content_mandarin: JSON.stringify({
            data: {
              title: data?.field_content_mandarin_title ?? "",
              description: data?.field_content_mandarin_description ?? "",
              image: data?.field_content_english_image ?? "",
              vision: {
                title: data?.field_content_mandarin_vision_title ?? "",
                description: data?.field_content_mandarin_vision_description ?? "",
                image: data?.field_content_english_vision_image ?? "",
              },
              brandPromise: {
                title: data?.field_content_mandarin_brandPromise_title ?? "",
                description: data?.field_content_mandarin_brandPromise_description ?? "",
                image: data?.field_content_english_brandPromise_image ?? "",
              },
              nextPage: {
                name: data?.field_content_mandarin_nextPage_name ?? "",
                link: data?.field_content_mandarin_nextPage_link ?? "",
              },
            },
          }),
          field_page: brandData?.[0]?.field_page || brandDataById?.payload?.field_page || "",
          published: true,
        },
        status: status,
      };
    }

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  if (isLoading || isLoadingBrand) {
    return <Loader />;
  }

  return (
    <>
      <DynamicForm
        isLoading={isLoading || isLoadingBrand}
        config={OurBrandFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${corporateHost}/api/page-content/${brandData?.[0]?.id || brandDataById?.payload?.id || "65"}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Corporate Profile"
      />
    </>
  );
};
